import { Typography } from '@mui/material';
import parse from 'html-react-parser';

import { MessageItemSectionProps } from '../../MessageList.interface';

import sanitizeHtml from 'modules/common/utils/sanitizeHtml';

export default function DescriptionSection({ ticket }: MessageItemSectionProps) {
    const lastComment = ticket.last_comment?.public ? ticket.last_comment : undefined;

    return (
        <Typography
            component="span"
            variant="body2"
            color="cement.500"
            sx={{
                display: '-webkit-box',
                WebkitLineClamp: 2,
                WebkitBoxOrient: 'vertical',
                lineClamp: 2,
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                marginTop: 1,
                '& em': {
                    backgroundColor: 'purple.50',
                    paddingX: '2px',
                    color: 'black',
                    fontStyle: 'normal',
                },
            }}>
            {parse(sanitizeHtml(lastComment?.plain_body ?? ''))}
        </Typography>
    );
}
